import { render, staticRenderFns } from "./WrapNotes.vue?vue&type=template&id=eb3a561a&scoped=true"
import script from "./WrapNotes.vue?vue&type=script&lang=js"
export * from "./WrapNotes.vue?vue&type=script&lang=js"
import style0 from "./WrapNotes.vue?vue&type=style&index=0&id=eb3a561a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3a561a",
  null
  
)

export default component.exports